import { FunctionComponent } from "react";
import { Button, Input, Dialog } from '../../tailwindcomponents';

type CreateGroupProps = {
    isOpen: boolean,
    setIsOpen: Function,
    groupName: string,
    setGroupName: Function,
    groupPermission: string,
    setPermission: Function,
    onCreateGroup: Function,
}

const CreateGroup: FunctionComponent<CreateGroupProps> = ({ isOpen, setIsOpen, groupName, setGroupName, groupPermission, setPermission, onCreateGroup }) => {
    return (
        <Dialog
            visible={isOpen}
            max_width={"md"}
            title={"Create group"}
            context={
                <div className="flex flex-col">
                    <div>
                        <div className="flex flex-row flex-wrap">
                            <div className="mr-[120px]" >
                                <Input
                                    multiline={false}
                                    label_text="Group name"
                                    help_text="Please type in a name for the new group"
                                    type="text"
                                    value={groupName}
                                    width={150}
                                    onTextChange={(value: string) => setGroupName(value)}
                                />
                            </div>
                            <div>
                                <Input
                                    multiline={false}
                                    label_text="Group permission"
                                    help_text="Please type in permisson for the new group"
                                    type="text"
                                    value={groupPermission}
                                    width={200}
                                    onTextChange={(value: string) => setPermission(value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="mt-4">
                        <Button variant="contained" color='primary' className="mb-8" onClick={() => onCreateGroup()}>Submit</Button>
                    </div>
                </div>
            }
            onClose={(status: any) => setIsOpen(false)}
            strict={false}
            show_options={false}
        />
    )
}
export default CreateGroup